export default __webpack_public_path__ + "static/media/data-sbc.7bfc8ee7.webp";